<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="form.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="创建人" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人" v-trim/>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入编辑人" v-trim/>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="form.info" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="订单编码（关联goodsorder)" prop="orderId">
        <el-input v-model="form.orderId" placeholder="请输入订单编码（关联goodsorder)" v-trim/>
      </el-form-item>
      <el-form-item label="用户编码（关联member表）" prop="memberId">
        <el-input v-model="form.memberId" placeholder="请输入用户编码（关联member表）" v-trim/>
      </el-form-item>
      <el-form-item label="交易金额" prop="money">
        <el-input v-model="form.money" placeholder="请输入交易金额" v-trim/>
      </el-form-item>
      <el-form-item label="交易类型 0租车押金 1结算实际消费 2结算退款 3平台退款" prop="type">
        <el-input v-model="form.type" placeholder="请输入交易类型 0租车押金 1结算实际消费 2结算退款 3平台退款" v-trim/>
      </el-form-item>
      <el-form-item label="详细地址" prop="preOrderid">
        <el-input v-model="form.preOrderid" placeholder="请输入详细地址" v-trim/>
      </el-form-item>
      <el-form-item label="详细地址" prop="onlineOrderid">
        <el-input v-model="form.onlineOrderid" placeholder="请输入详细地址" v-trim/>
      </el-form-item>
      <el-form-item label="交易完成时间" prop="doneDate">
        <el-input v-model="form.doneDate" placeholder="请输入交易完成时间" v-trim/>
      </el-form-item>
      <el-form-item label="交易标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入交易标题" v-trim/>
      </el-form-item>
      <el-form-item label="交易内容" prop="content">
        <el-input v-model="form.content" placeholder="请输入交易内容" v-trim/>
      </el-form-item>
      <el-form-item label="用户当前余额(分）" prop="balance">
        <el-input v-model="form.balance" placeholder="请输入用户当前余额(分）" v-trim/>
      </el-form-item>
      <el-form-item label="交易关联对象类型 0订单 1退款单" prop="objType">
        <el-input v-model="form.objType" placeholder="请输入交易关联对象类型 0订单 1退款单" v-trim/>
      </el-form-item>
      <el-form-item label="交易关联对象编码" prop="objId">
        <el-input v-model="form.objId" placeholder="请输入交易关联对象编码" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaTransactionsWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        info: '',
        orderId: '',
        memberId: '',
        money: '',
        type: '',
        preOrderid: '',
        onlineOrderid: '',
        doneDate: '',
        title: '',
        content: '',
        balance: '',
        objType: '',
        objId: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/transactions',
      'field.id': 'id'
    })
  }
}
</script>
